import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, ChevronRight, Sparkles } from 'lucide-react';
import api from '../api';
import StatusBadge from '../components/StatusBadge';

export default function Homologation() {
  const [items, setItems] = useState([]);
  const [stats, setStats] = useState({});
  const [tab, setTab] = useState('pending');
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [products, setProducts] = useState([]);
  const [searchProduct, setSearchProduct] = useState('');

  const loadQueue = async () => {
    setLoading(true);
    try {
      const result = await api.homologation(`status=${tab}`);
      setItems(result.items || []);
      setStats(result.stats || {});
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => { loadQueue(); }, [tab]);

  useEffect(() => {
    api.catalog('limit=500').then(r => setProducts(r.products || [])).catch(() => {});
  }, []);

  const handleApprove = async (itemId, productId) => {
    try {
      await api.approveHomologation(itemId, { product_id: productId });
      loadQueue();
      setSelected(null);
    } catch (err) { console.error(err); }
  };

  const handleReject = async (itemId) => {
    try {
      await api.rejectHomologation(itemId);
      loadQueue();
      setSelected(null);
    } catch (err) { console.error(err); }
  };

  const filteredProducts = products.filter(p => {
    if (!searchProduct) return true;
    const s = searchProduct.toLowerCase();
    return p.canonical_name?.toLowerCase().includes(s) || p.sku_internal?.toLowerCase().includes(s);
  });

  return (
    <div>
      <div className="tab-buttons" data-testid="homologation-queue-tabs">
        <button className={`tab-btn ${tab === 'pending' ? 'active' : ''}`} onClick={() => setTab('pending')}>Pendientes ({stats.pending || 0})</button>
        <button className={`tab-btn ${tab === 'approved' ? 'active' : ''}`} onClick={() => setTab('approved')}>Aprobados ({stats.approved || 0})</button>
        <button className={`tab-btn ${tab === 'rejected' ? 'active' : ''}`} onClick={() => setTab('rejected')}>Rechazados ({stats.rejected || 0})</button>
      </div>

      {loading ? (
        <div className="loading-spinner"><div className="spinner" /></div>
      ) : items.length === 0 ? (
        <div className="empty-state">
          <CheckCircle size={48} />
          <h3>{tab === 'pending' ? 'Sin productos pendientes' : `Sin productos ${tab === 'approved' ? 'aprobados' : 'rechazados'}`}</h3>
          <p>Carga un archivo con productos para iniciar la homologación.</p>
        </div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns: selected ? '1fr 400px' : '1fr',gap:'16px'}}>
          <div className="data-table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Nombre capturado</th>
                  <th>Match sugerido</th>
                  <th>Score</th>
                  <th>Confianza</th>
                  {tab === 'pending' && <th>Acciones</th>}
                </tr>
              </thead>
              <tbody>
                {items.map(item => (
                  <tr key={item._id} data-testid="homologation-item-row" style={{cursor:'pointer',background: selected?._id === item._id ? 'hsl(var(--muted)/0.5)' : ''}} onClick={() => setSelected(item)}>
                    <td style={{fontWeight:500}}>{item.dirty_name}</td>
                    <td style={{fontSize:'0.78rem'}}>{item.match?.canonical_name || '-'}</td>
                    <td>
                      <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                        <div className="confidence-bar" style={{width:'60px'}} data-testid="homologation-confidence-progress">
                          <div className={`confidence-bar-fill ${item.score >= 0.92 ? 'high' : item.score >= 0.80 ? 'medium' : 'low'}`} style={{width:`${(item.score || 0) * 100}%`}} />
                        </div>
                        <span style={{fontSize:'0.72rem',fontVariantNumeric:'tabular-nums'}}>{((item.score || 0) * 100).toFixed(0)}%</span>
                      </div>
                    </td>
                    <td><StatusBadge status={item.confidence} /></td>
                    {tab === 'pending' && (
                      <td>
                        <div style={{display:'flex',gap:'4px'}}>
                          {item.match && (
                            <button className="btn btn-sm btn-success" data-testid="homologation-approve-button" onClick={(e) => { e.stopPropagation(); handleApprove(item._id, item.match.product_id); }}>
                              <CheckCircle size={12} />
                            </button>
                          )}
                          <button className="btn btn-sm btn-danger" data-testid="homologation-reject-button" onClick={(e) => { e.stopPropagation(); handleReject(item._id); }}>
                            <XCircle size={12} />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Detail panel */}
          {selected && (
            <div className="section-card" style={{position:'sticky',top:'80px',maxHeight:'calc(100vh - 120px)',overflowY:'auto'}} data-testid="homologation-details-drawer">
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
                <h3 style={{fontSize:'0.9rem'}}>Detalle</h3>
                <button className="btn btn-sm btn-secondary" onClick={() => setSelected(null)}><XCircle size={12} /></button>
              </div>
              <div className="drawer-section">
                <h4>Texto capturado</h4>
                <p style={{fontSize:'0.85rem',fontWeight:500,background:'hsl(var(--muted)/0.5)',padding:'10px 12px',borderRadius:'8px'}}>{selected.dirty_name}</p>
              </div>
              {selected.match && (
                <div className="drawer-section">
                  <h4>Match sugerido</h4>
                  <div className="drawer-row"><span className="label">Producto</span><span className="value">{selected.match.canonical_name}</span></div>
                  <div className="drawer-row"><span className="label">SKU</span><span className="value">{selected.match.sku_internal}</span></div>
                  <div className="drawer-row"><span className="label">Score</span><span className="value">{((selected.score || 0) * 100).toFixed(1)}%</span></div>
                  <div className="drawer-row"><span className="label">Método</span><span className="value" style={{fontSize:'0.72rem'}}>{selected.method}</span></div>
                </div>
              )}
              {tab === 'pending' && (
                <div className="drawer-section">
                  <h4>Asignar producto manualmente</h4>
                  <input className="form-input" placeholder="Buscar producto..." value={searchProduct} onChange={e => setSearchProduct(e.target.value)} style={{marginBottom:'8px'}} />
                  <div style={{maxHeight:'200px',overflowY:'auto'}}>
                    {filteredProducts.slice(0, 20).map(p => (
                      <div key={p.product_id} style={{padding:'6px 8px',fontSize:'0.78rem',cursor:'pointer',borderRadius:'6px',display:'flex',justifyContent:'space-between',alignItems:'center'}} className="sidebar-nav-item" onClick={() => handleApprove(selected._id, p.product_id)}>
                        <span>{p.canonical_name}</span>
                        <ChevronRight size={12} />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
